/**
 * Dernier cran prêté à une échelle d'évaluation dont le paramétrage ne dit rien — le nombre
 * d'icônes, quand elle se note en dessins. Une question tout juste déposée sur le canevas se note
 * ainsi de un à cinq.
 */
export const DEFAULT_SCALE_RANGE = 5;
